export const ApiEndpoint = 'https://sistema.jmmasesores.com/api/';
//export const ApiEndpoint = 'http://127.0.0.1:3001/';
//export const ApiEndpoint = 'http://216.238.92.20/api/';
export const getParameterById = key => {
  if (typeof window !== 'undefined') {
    var query = window && window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (pair[0] == key) {
        return pair[1];
      }
    }
  }
  return 1;
};
